// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { ProductionDeclarationSubmissionPage } from '@/pages/production-declaration/production-declaration-submission-page';
import { Route as ProductionDeclarationRoute } from './production-declarations.$id';

export const Route = createRoute({
  getParentRoute: () => ProductionDeclarationRoute,
  path: 'submission',
  component: () => <ProductionDeclarationSubmissionPage />,
  staticData: {
    stepKey: 'submission',
  },
});
